import React from 'react';
import TableHeadMui, { TableHeadProps } from '@material-ui/core/TableHead';

export const TableHead: React.FC<TableHeadProps> = ({ children, ...rest }) => {
	return <TableHeadMui {...rest}>{children}</TableHeadMui>;
};
